module.exports = __webpack_public_path__ + "static/media/jade-on.923a33b9.png";